import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorDiscountBuy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M3 12a8.25 8.25 0 1 1 16.5 0 .75.75 0 0 0 1.5 0c0-5.385-4.365-9.75-9.75-9.75S1.5 6.615 1.5 12a9.743 9.743 0 0 0 4.551 8.25H2.25a.75.75 0 0 0 0 1.5h10.447a2.25 2.25 0 0 0 1.573-.641L18 17.464a.75.75 0 0 1 .524-.214h3.227a.75.75 0 0 0 0-1.5h-3.227a2.25 2.25 0 0 0-1.573.641l-3.728 3.645a.75.75 0 0 1-.525.214H11.25A8.25 8.25 0 0 1 3 12Zm15 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 18 21Z"
    />
    <path
      fill="#F7A600"
      d="M15.586 7.704a.756.756 0 0 1 0 1.07L8.1 16.26a.756.756 0 0 1-1.07-1.07l7.488-7.487a.756.756 0 0 1 1.07 0ZM13.917 14.062a.605.605 0 1 0 0 1.21.605.605 0 0 0 0-1.21Zm-1.664.605a1.664 1.664 0 1 1 3.328 0 1.664 1.664 0 0 1-3.328 0ZM8.623 8.768a.605.605 0 1 0 0 1.21.605.605 0 0 0 0-1.21Zm-1.664.605a1.664 1.664 0 1 1 3.327 0 1.664 1.664 0 0 1-3.327 0Z"
    />
  </svg>
);
export default SvgTwoColorDiscountBuy;
